// extracted by mini-css-extract-plugin
export default {"form":"Entry_form__toVv9","formTitle":"Entry_formTitle__fbdVx","button":"Entry_button__Q88I+","field":"Entry_field__FfSM9","loader":"Entry_loader__tsP1i","hide":"Entry_hide__7Ghyi"};